import { StoryType } from 'src/app/story/models/story-type.enum';
import { TrimConfiguration } from 'src/app/edit/models/trim-config.model';
import { SaveModuleConfigModel } from '../models/save-module-config.model';
import { StoryModel } from 'src/app/story/models/story.model';
import { SaveModuleModel } from '../models/save-module.model';

export class Serialize {
  static readonly type = '[Modules] Serialize'; // Serialize active story
  constructor(public type: StoryType) {}
}

export class SaveModule {
  static readonly type = '[Modules] Save Module';
  constructor(public id: string, public saveConfig: SaveModuleConfigModel, public trimConfig?: TrimConfiguration) {}
}

export class SaveModuleSuccess {
  static readonly type = '[Modules] Save Module Success';
  constructor(public id: string) {}
}

export class SaveModuleFailure {
  static readonly type = '[Modules] Save Module Failure';
  constructor(public id: string) {}
}

export class DuplicateModuleSuccess {
  static readonly type = '[Modules] Duplicate Module Success';
  constructor(public id: string) {}
}

export class DuplicateModuleFailure {
  static readonly type = '[Modules] Duplicate Module Failure';
  constructor(public id: string) {}
}

export class SaveModuleThumbnails {
  static readonly type = '[Modules] Save Module Thumbnails';
  constructor(
    public id: string, 
    public serialized: {
      story: StoryModel,
      chapterIdMap: {[key: string]: string}
    // namespaceMap: {[key: string]: string}
    },
    public saveConfig: SaveModuleConfigModel) {}
}

export class SetSaveModule {
  static readonly type = '[Modules] Set Save Module';
  constructor(public module: SaveModuleModel) {}
}

export class GetModulePrimaryCategories {
  static readonly type = '[Modules] Get Primary Categories';
  constructor() {}
}

export class GetModuleSecondaryCategories {
  static readonly type = '[Modules] Get Secondary Categories';
  constructor(public primaryCategory: string) {}
}

export class ResetModules {
  static readonly type = '[Modules] Reset';
  constructor() { }
}
